export const ROOT_ROLE = "ROOT";
